/**
 * React Query keys for follow-ups (own module so the query/mutation/cache files can share them
 * without importing each other).
 */
export const followUpKeys = {
  all: ['followUps'],
  // Chat Details: per-conversation lists → [..., conversationId, { search }]
  lists: () => [...followUpKeys.all, 'list'],
  byConversation: (conversationId) => [...followUpKeys.lists(), conversationId],
  list: (conversationId, search = '') => [...followUpKeys.byConversation(conversationId), { search }],
};

// Follow-ups page: one follow-up's activity log → [..., followUpId]
export const followUpActivityLogKeys = {
  all: [...followUpKeys.all, 'activityLogs'],
  byFollowUp: (followUpId) => [...followUpActivityLogKeys.all, followUpId],
};

export const followUpsModuleKeys = {
  all: [...followUpKeys.all, 'module'],
  // Follow-ups page: tenant-wide lists per tab → [..., tab, search, dayKey]
  lists: () => [...followUpsModuleKeys.all, 'list'],
  list: (tab, search, dayKey) => [...followUpsModuleKeys.lists(), tab, search, dayKey],
};
